import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const NotFound = () => (
  <div className="bg-black min-h-screen text-white flex flex-col">
    <SEO
      title="Page Not Found | Claim Beast Public Adjusters"
      description="The page you're looking for doesn't exist. Head home or call us for a free claim review."
      path="/404"
      noindex
    />
    <Header />
    <main className="flex-1 flex items-center justify-center px-4 py-24">
      <div className="text-center max-w-lg">
        <div
          className="text-[#E11D26] text-7xl sm:text-9xl font-black"
          style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
        >
          404
        </div>
        <h1
          className="mt-4 text-white text-3xl sm:text-4xl font-black uppercase"
          style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
        >
          Page Not Found
        </h1>
        <p className="mt-4 text-white/65">
          That page took a charge from the rhino. Let's get you back on track.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-3 bg-[#E11D26] hover:bg-[#c11820] text-white font-bold uppercase tracking-wider px-7 py-4 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span className="text-sm">Back to Home</span>
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);

export default NotFound;
